import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { ActionPayload, DataLakeFileDeleteRequestInput } from '../gql-types.generated';

export const MUTATION_DELETE_FILE = gql`
    mutation deleteDataLakeFile($input: DataLakeFileDeleteRequestInput!){
        deleteDataLakeFile(input: $input){
            message
            result
            errors {
                code
                message
            }
        }
    }
`;

export const mutationDeleteDataLakeFile = async (
    client: ApolloClient<NormalizedCacheObject>,
    fileNamesWithFullPaths: string[]
): Promise<ActionPayload | undefined> => {
    const { data, errors } = await client.mutate<{ deleteDataLakeFile: ActionPayload }>({
        variables: { 
            input: {
                fileNamesWithFullPaths
            } as DataLakeFileDeleteRequestInput
         },
        mutation: MUTATION_DELETE_FILE
    });
    if (errors && errors.length > 0) {
        errors.forEach(error => {
            // Log error details in the console
            console.error(error);
        });
        // friendly error to user
        throw new Error('An error has occurred during the file delete.');
    }
    if (data && data.deleteDataLakeFile) {
        return data.deleteDataLakeFile;
    }

    return undefined;
};